<template>
    <div class="contacts-assets">
        <slot />
        <template v-if="data">
            <div>
                <div class="contacts-assets__filter" v-if="data.filters">
                    <z-select
                        name="type"
                        v-if="data.filters.type"
                        :data="data.filters.type"
                        :placeholder="text.selectPlacholder"
                        @change="filterChanged"
                    />
                </div>
            </div>
            <div class="u-top-margin--double">
                <div
                    class="row"
                    v-for="(item, index) in data.items"
                    :key="index"
                    v-show="!params.type || item.type.includes(params.type)"
                >
                    <div class="col-default-6 col-v-tablet-12">
                        <contacts-map
                            :center="transformCoords(item.map.center)"
                            :coords="transformCoords(item.map.coords)"
                            :lang="lang"
                        />
                    </div>
                    <div class="col-default-6 col-v-tablet-12">
                        <z-card
                            theme="colored"
                            :divider-color="setColorDivider(item.type)"
                            :artline="false"
                        >
                            <template v-slot:top-left>
                                {{ item.name }}
                            </template>
                            <template v-slot:content>
                                <div class="card-contact">
                                    <span class="card-contact__item" v-if="item.address">
                                        <z-icon name="placeholder" width="24" height="24"></z-icon>
                                        {{ item.address }}
                                    </span>
                                    <z-link
                                        v-for="(phone, index) in checkArray(item.phone)"
                                        :key="`phone-${index}`"
                                        :href="`tel:${transformString(phone)}`"
                                        theme="black"
                                    >
                                        <z-icon name="phone" width="24" height="24"></z-icon>
                                        {{ transformString(phone) }}
                                    </z-link>
                                    <z-link
                                        v-for="(email, index) in checkArray(item.email)"
                                        :key="`email-${index}`"
                                        :href="`mailto:${email}`"
                                    >
                                        <z-icon name="email" width="24" height="24"></z-icon>
                                        {{ email }}
                                    </z-link>
                                </div>
                            </template>
                        </z-card>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import ContactsMap from './Map.vue'

export default {
    name: 'contacts-assets',
    props: {
        data: [Array, Object]
    },
    components: {
        ContactsMap
    },
    data () {
        return {
            params: {
                type: undefined
            },
            lang: this.$root.lang,
            text: {
                selectPlacholder: localize({
                    ru: 'Тип производства',
                    en: 'Production type'
                })
            }
        }
    },
    methods: {
        filterChanged (data) {
            this.params.type = data
        },
        transformCoords (data) {
            return data.split(',').map(point => parseFloat(point.trim()))
        },
        transformString (string) {
            return string.split(':')[0]
        },
        checkArray (data) {
            if (data && data.length) return data
        },
        setColorDivider (type) {
            if (type && type.length) {
                let color

                type.forEach(item => {
                    switch (item) {
                    case 'steel':
                        color = 'yellow'
                        break
                    case 'coal':
                        color = 'orange'
                        break
                    case 'ruda':
                        color = 'red'
                        break
                    case 'vanadium':
                        color = 'purple'
                        break
                    case 'logistic':
                        color = 'gray-roze'
                        break
                    default:
                        color = 'yellow'
                        break
                    }
                })

                return color
            }
        }
    }
}
</script>

<style lang="scss">
.contacts-assets {
    &__filter {
        background: #F8F8F8;
        padding: $token-spacers-m;

        .z-select {
            max-width: 50%;

            @include breakpoint (v-tablet) {
                max-width: none;
            }
        }
    }
}
</style>
